const recursoEnumerators = {
  tipo: ['Recurso Humano', 'Inventario', 'Servicios', 'Repuestos y Suministros'],
};

export default recursoEnumerators;
